import type { LessonRecurringPayload } from '../../model/lessons/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonRecurringApiOptions {
  disciplineId: string | number
  payload: LessonRecurringPayload & { tutor_id: number | null }
  onStart?: () => void
  onFinish?: () => void
}

/** `POST /admin-api/disciplines/{discipline}/recurring-lessons` — only QUEUES the creation (202): the lessons come
 *  later, announced on the discipline channel. Not guarded against a duplicate, so never retried on its own. */
export const useLessonRecurringApi = async (options: LessonRecurringApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.recurring', { discipline_id: options.disciplineId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.post<ApiResponse>(url, options.payload)

    toast.info('Recurring lessons are being created.')

    return true
  } catch (err: unknown) {
    toast.error({
      title: 'Error on recurring create!',
      description: getAxiosErrorMessage(err),
    })

    return false
  } finally {
    options.onFinish?.()
  }
}
